import axiosInstance from "../axiosInstance";

export const cambiarActivoPostventa = async (
  adminId,
  idPostventa,
  numeroTitulares,
  activo,
  nuevoIdPostventa
) => {
  return await axiosInstance.patch(
    `${process.env.REACT_APP_BASE_URL}/postventa-cambiarActivo`,
    {
      adminId,
      idPostventa,
      numeroTitulares,
      activo,
      nuevoIdPostventa,
    }
  );
};
